export default __webpack_public_path__ + "static/media/logo_500x500white.3735c999.png";